import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {showMessage} from '../features/message/messageSlice';
import {logoutAsync} from '../features/user/userSlice';
import {setFetching, setViewings} from '../features/viewing/viewing-slice';
import {setProfileInitialData} from '../features/tenant/tenantSlice';
import {SLUG_LOGIN} from '../utils/constants';

function useLogoutMutation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(showMessage({show: false, text: ''}));
    return dispatch(logoutAsync()).then(() => {
      dispatch(setFetching(false));
      dispatch(setViewings([]));
      dispatch(setProfileInitialData());
      navigate(SLUG_LOGIN);
    });
  };

  return [logout];
}

export default useLogoutMutation;
